module.exports = __webpack_public_path__ + "static/media/Complete-Care-Logo.46b344f3.png";